export type PageMeta = { page: number; page_size: number; total: number };

/** The next page number, or undefined on the last page. */
export const nextPage = (p: PageMeta): number | undefined => (p.page * p.page_size < p.total ? p.page + 1 : undefined);

